/**
 * Copyright (c) 2018 - present, Inbenta Technologies Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

(function () {
  /**
   * Function to display terms of service
   */
  window.displayTermsOfService = function() {
    let termsDiv = document.querySelector('#webform-terms-of-service-terms_of_service--description').parentElement.parentElement;
    termsDiv.style.display = 'block';
  }
  /**
   * Function to display rating comment step.
   */
  function displayMore(qty) {
    let hiddenNews = document.querySelectorAll('.inbenta-km__resources .inbenta-km__faq--hidden');

    // Get months  to display
    for (let i = 0; i < qty; i++) {
      if (hiddenNews[i]) {
        if (hiddenNews[i].classList.contains('inbenta-km__faq--hidden')) {
          hiddenNews[i].classList.toggle('inbenta-km__faq--hidden')
        }
      }
    }

    if (document.querySelectorAll('.inbenta-km__resources .inbenta-km__faq--hidden').length === 0) {
      hideLoaderButton();
    }

    updateLoader();
  }

  function updateLoader() {
    const totalResources = document.querySelectorAll('.inbenta-km__resources .inbenta-km__faq').length;
    const hiddenResources = document.querySelectorAll('.inbenta-km__resources .inbenta-km__faq--hidden').length;
    const displayedResources = totalResources - hiddenResources;


    document.querySelector('.inbenta-km__resources__loader .loader-text__count').innerHTML = displayedResources.toString();
    const loadedWidth = displayedResources * 224 / totalResources;
    const bar = document.querySelector('.inbenta-km__resources .inbenta-km__resources__loader .inbenta-km__resources__loader-bar-progression');
    bar.style.width = Math.round(loadedWidth) + 'px';
  }

  function hideLoaderButton() {
    var seeMorebutton = document.querySelector('.inbenta-km__resources .inbenta-km__resources__loader .button--secondary--yellow')
    seeMorebutton.style.display = 'none'
  }

  /**
   * Main function.
   */
  window.addEventListener('load', function () {
    if (document.querySelectorAll('.inbenta-km__resources').length && document.querySelectorAll('.inbenta-km__resources__loader').length) {
      var qty = 6;
      displayMore(qty);

      var seeMorebutton = document.querySelector('.inbenta-km__resources .inbenta-km__resources__loader .button--secondary--yellow');
      seeMorebutton.addEventListener('click', function () {
        displayMore(qty);
      });
    }
  });
})()
